function handleOnThisPage() {
  const onThisPage = document.querySelector('.on-this-page');

  if (!onThisPage) return;

  const buttonCollapse = onThisPage.querySelector('.button-collapse');
  const linksBlock = onThisPage.querySelector('.on-this-page__links');

  if (buttonCollapse && linksBlock) {
    let clickCount = 0;
    const linksBlockHeight = linksBlock.scrollHeight;
    linksBlock.style.maxHeight = `${linksBlockHeight}px`;

    buttonCollapse.addEventListener('click', (e) => {
      e.preventDefault();

      if (clickCount % 2 == 0) {
        linksBlock.style.maxHeight = 0;
        onThisPage.classList.add('up');
        clickCount++;
      } else {
        linksBlock.style.maxHeight = `${linksBlockHeight}px`;
        onThisPage.classList.remove('up');
        clickCount++;
      }
    });
  }
}

window.addEventListener('load', handleOnThisPage);
